import React from 'react'
import clsx from 'clsx'
import { Checkbox as AntCheckbox } from 'antd'
import {
  CheckboxProps as AntCheckboxProps,
  CheckboxGroupProps as AntCheckboxGroupProps
} from 'antd/lib/checkbox'

import s from './checkbox.module.css'

export type CheckboxProps = AntCheckboxProps & { rounded?: boolean }
export type CheckboxGroupProps = AntCheckboxGroupProps

export const Checkbox: React.FC<CheckboxProps> = ({
  className,
  children,
  checked,
  name,
  defaultChecked,
  disabled,
  onChange,
  rounded = false
}) => {
  const controlledProps = {
    ...(checked !== undefined && { checked })
  }

  return (
    <AntCheckbox
      className={clsx(className, {
        [s.selector]: rounded
      })}
      defaultChecked={defaultChecked}
      disabled={disabled}
      onChange={onChange}
      name={name}
      {...controlledProps}
    >
      {children}
    </AntCheckbox>
  )
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  children,
  className,
  disabled,
  name,
  onChange,
  options,
  value,
  defaultValue
}) => {
  const controlledProps = {
    ...(value !== undefined && { value })
  }
  return (
    <AntCheckbox.Group
      className={className}
      disabled={disabled}
      options={options}
      name={name}
      onChange={onChange}
      defaultValue={defaultValue}
      {...controlledProps}
    >
      {children}
    </AntCheckbox.Group>
  )
}
